import { Button, Theme } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PurchaseTermsSection.css';
import { PurchaseTermsOnboarding } from '../../containers/PurchaseTermsContainer/PurchaseTermsOnboarding';

interface IPurchaseTermsPromoProps {
  onMoreButtonClick(): void;
  isModalOpen: boolean;
}

export const PurchaseTermsSection: React.FC<React.PropsWithChildren<IPurchaseTermsPromoProps>> = ({
  onMoreButtonClick,
  isModalOpen,
  children,
}) => {
  return (
    <div className={styles['container']} data-testid="PurchaseTermsSection">
      <div>{children}</div>
      <div className={styles['more-button']}>
        <Theme theme="onOverlay">
          <PurchaseTermsOnboarding isModalOpen={isModalOpen} isRedesign={true}>
            <Button
              fullWidth
              onClick={onMoreButtonClick}
              theme="fill_secondary"
              data-testid="PurchaseTermsSectionMoreButton"
            >
              Ещё способы покупки
            </Button>
          </PurchaseTermsOnboarding>
        </Theme>
      </div>
    </div>
  );
};
